import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { shouldHideAppChrome } from './landingConfig';

/*
 * Hides the app-wide <Header /> and <Footer /> on the public landing route.
 *
 * The landing page brings its own sticky header and its own footer. The app's
 * <Footer /> is position:fixed bottom, so without this it sits on top of the
 * landing page's footer, and the app <Header /> stacks above the landing one.
 *
 * On every other route this renders its children unchanged, so nothing else in
 * the app is affected.
 *
 * Usage in src/routers/AppRouter.js:
 *     <AppChrome><Header /></AppChrome>
 *     ...
 *     <AppChrome><Footer /></AppChrome>
 */
const AppChrome = ({ location, children }) =>
    (shouldHideAppChrome(location.pathname) ? null : children);

AppChrome.propTypes = {
    location: PropTypes.object.isRequired,
    children: PropTypes.node,
};

export default withRouter(AppChrome);



// WEBPACK FOOTER //
// src/pages/landing/AppChrome.js